<template>
  <v-app-bar app clipped-left>
    <v-app-bar-nav-icon @click.stop="onClickNavBarIcon"></v-app-bar-nav-icon>
    <div class="d-flex align-center">
      <v-img
          :src="require('~/assets/logo.svg')"
          alt="Igreja"
          class="shrink mr-2"
          contain
          transition="scale-transition"
          width="140"
      />
    </div>
    <v-spacer></v-spacer>
    <Navbar/>
  </v-app-bar>
</template>
<script>
import Navbar from "./Navbar";
export default {
  name: 'Header',
  components: {Navbar},
  methods: {
    onClickNavBarIcon() {
      this.$emit('clickedNavBarIcon')
    }
  }
}
</script>